export default "__VITE_ASSET__BKfRdsr1__"